import React from 'react';

import classnames from 'classnames';

type CloseIconProps = {
  className: string;
};

const CloseIcon = ({ className }: CloseIconProps) => (
  <svg className={classnames(className)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20">
    <path d="M4.2 18.38L10.57 12 4.2 5.63l1.39-1.4 6.37 6.38 6.38-6.38 1.39 1.4L13.36 12l6.37 6.38-1.39 1.39-6.38-6.38-6.37 6.38-1.39-1.39z" />
  </svg>
);

export default CloseIcon;
